<template>
    <div class="wf-field">
        <label class="wf-label">
            {{ label }} <span v-if="isRequired" class="wf-required">*</span>
        </label>
        <p v-if="instruction" class="wf-instruction">{{ instruction }}</p>
        <div class="wf-rating">
            <button
                v-for="star in maxStars"
                :key="star"
                type="button"
                class="wf-rating-star"
                :class="{ 'is-active': star <= (value || 0) }"
                @click="emitValue(star)"
            >
                <i :class="star <= (value || 0) ? 'fas fa-star' : 'fal fa-star'"></i>
            </button>
        </div>
        <p v-if="help" class="wf-help">{{ help }}</p>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import FieldMixin from './FieldMixin'
import { readRatingMax } from '@/config/rating'

export default {
    name: 'RatingField',
    mixins: [FieldMixin],
    computed: {
        // Échelle définie dans le builder ; 5 étoiles pour un champ créé avant ce réglage.
        maxStars() {
            return readRatingMax(this.attribute.config)
        }
    }
}
</script>
